// ** Dropdowns Imports
// ** Third Party Components
import NavbarSearch from "./NavbarSearch";

const NavbarUser = (props) => {
  const showNavbarSearch = document.location.pathname.includes("/tokens") || document.location.pathname.includes("/contracts");

  return (
    <>
      {" "}
      {showNavbarSearch && (
        <ul style={{ width: "100%" }} id="navbarSearchWrapper" className="nav navbar-nav align-items-center mr-auto">
          <NavbarSearch />
        </ul>
      )}
    </>
  );
};
export default NavbarUser;
